import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';
import { Form } from 'antd';
import { useForm } from 'antd/es/form/Form';
import Modal from '../../../../components/Modal';
import AntdInput from '../../../../components/AntdInput';
import AntdFormItem from '../../../../components/AntdFormItem';
import AccionaButton from '../../../../components/AccionaButton';

const ProviderConfigModal = ({
  open,
  closeModal,
  setConfgProvider,
  confProvider,
  proyectValues,
  deleteProvider,
  idProviderModal,
  setSelectedProviders,
}) => {
  const intl = useIntl();
  const [form] = useForm();
  const mainRules = [
    {
      required: true,
      message: intl.formatMessage({ id: 'validations.required' }),
    },
  ];

  const handleOnFinish = (values) => {
    setConfgProvider(values);
    closeModal();
  };

  const handleOnCancel = (values) => {
    if (!Object.keys(confProvider).length) {
      const concrete_providers = proyectValues.concrete_providers.filter(
        (item) => item !== idProviderModal,
      );
      deleteProvider({
        ...proyectValues,
        concrete_providers,
      });
      setSelectedProviders(concrete_providers);
    }
    closeModal();
  };

  useEffect(() => {
    form.setFieldsValue(confProvider);
  }, [confProvider, form]);

  const getContentProvidersModal = () => {
    return (
      <div className="row" style={{ padding: '10px 20px' }}>
        <div
          className="col-sm-12 col-md-12"
          style={{ marginBottom: '40px', fontSize: '16px', zIndex: '-1' }}
        >
          {intl.formatMessage({
            id: `projects.create.concrete_providers.cemex.modal.title`,
          })}
        </div>
        <div className="col-sm-12 col-md-12" style={{ marginBottom: '100px' }}>
          <Form
            layout="vertical"
            form={form}
            onFinish={handleOnFinish}
            autocomplete="off"
            style={{ display: 'flex', flexWrap: 'wrap' }}
          >
            <AntdFormItem
              style={{ marginBottom: '20px', width: '100%' }}
              name="apikey"
              label={intl.formatMessage({
                id: 'projects.create.concrete_providers.cemex.modal.apikey',
              })}
              rules={[...mainRules, { min: 1 }]}
            >
              <AntdInput size="xLarge" />
            </AntdFormItem>
            <div style={{ padding: '0 10px 0 0', width: '50%' }}>
              <AntdFormItem
                style={{ marginBottom: '20px', width: '100%' }}
                name="username"
                label={intl.formatMessage({
                  id: 'projects.create.concrete_providers.cemex.modal.username',
                })}
                rules={[...mainRules, { min: 1 }]}
              >
                <AntdInput size="xLarge" />
              </AntdFormItem>
            </div>
            <div style={{ padding: '0 0 0 10px', width: '50%' }}>
              <AntdFormItem
                style={{ marginBottom: '20px', width: '100%' }}
                name="password"
                label={intl.formatMessage({
                  id: 'projects.create.concrete_providers.cemex.modal.password',
                })}
                rules={[...mainRules, { min: 1 }]}
              >
                <AntdInput size="xLarge" />
              </AntdFormItem>
            </div>
            <div style={{ padding: '0 10px 0 0', width: '50%' }}>
              <AntdFormItem
                style={{ marginBottom: '20px', width: '100%' }}
                name="customerCode"
                label={intl.formatMessage({
                  id: 'projects.create.concrete_providers.cemex.modal.customerCode',
                })}
                rules={[...mainRules, { min: 1 }]}
              >
                <AntdInput size="xLarge" />
              </AntdFormItem>
            </div>
            <div style={{ padding: '0 0 0 10px', width: '50%' }}>
              <AntdFormItem
                style={{ marginBottom: '20px', width: '100%' }}
                name="jobSite"
                label={intl.formatMessage({
                  id: 'projects.create.concrete_providers.cemex.modal.jobSite',
                })}
                rules={[...mainRules, { min: 1 }]}
              >
                <AntdInput size="xLarge" />
              </AntdFormItem>
            </div>
          </Form>
        </div>
        <div
          className="col-sm-12 col-md-12"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <AccionaButton
            onClick={() => handleOnCancel()}
            msg={intl.formatMessage({ id: 'cancel' })}
            type="default"
          ></AccionaButton>
          <AccionaButton
            onClick={() => form.submit()}
            msg={intl.formatMessage({ id: 'configure' })}
          ></AccionaButton>
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={open}
      onCancel={() => handleOnCancel()}
      width="50vw"
      closable
      id="confgProviderModal"
    >
      {getContentProvidersModal()}
    </Modal>
  );
};

ProviderConfigModal.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  setConfgProvider: PropTypes.func.isRequired,
  confProvider: PropTypes.object.isRequired,
  proyectValues: PropTypes.object.isRequired,
  deleteProvider: PropTypes.func.isRequired,
  idProviderModal: PropTypes.number.isRequired,
  setSelectedProviders: PropTypes.func.isRequired,
};

ProviderConfigModal.defaultProps = {
  open: false,
  closeModal: () => {},
  setConfgProvider: () => {},
  confProvider: {},
  proyectValues: {},
  deleteProvide: () => {},
  idProviderModal: 0,
  setSelectedProviders: () => {},
};

export default ProviderConfigModal;
